import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import FrameworkLayout from "@/components/framework/Layout";
import FrameworkHome from "@/pages/framework/Home";
import FrameworkCoaches from "@/pages/framework/Coaches";
import FrameworkServices from "@/pages/framework/Services";
import FrameworkStore from "@/pages/framework/Store";
import FrameworkSwing from "@/pages/framework/SwingAnalysis";
import FrameworkEvents from "@/pages/framework/Events";
import FrameworkStringing from "@/pages/framework/Stringing";
import FrameworkContact from "@/pages/framework/Contact";


import AdminDashboard, { AdminLogin } from "@/pages/admin/Admin";
import RequireAdmin from "@/components/RequireAdmin";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";

/**
 * String Theory brand was retired 2026-02 in favor of Framework Tennis.
 * All /stringtheory/* URLs now redirect to the Framework equivalent so
 * bookmarks and shared links still work.
 */
const ST_REDIRECTS = [
    ["/stringtheory", "/framework"],
    ["/stringtheory/coaches", "/framework/coaches"],
    ["/stringtheory/services", "/framework/services"],
    ["/stringtheory/store", "/framework/store"],
    ["/stringtheory/swing-analysis", "/framework/swing-analysis"],
    ["/stringtheory/events", "/framework/events"],
    ["/stringtheory/stringing", "/framework/stringing"],
    ["/stringtheory/contact", "/framework/contact"],
];

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <Routes>
                    {/* Root goes straight to Framework — the chosen brand */}
                    <Route path="/" element={<Navigate to="/framework" replace />} />

                    <Route path="/framework" element={<FrameworkLayout />}>
                        <Route index element={<FrameworkHome />} />
                        <Route path="coaches" element={<FrameworkCoaches />} />
                        <Route path="services" element={<FrameworkServices />} />
                        <Route path="store" element={<FrameworkStore />} />
                        <Route path="swing-analysis" element={<FrameworkSwing />} />
                        <Route path="events" element={<FrameworkEvents />} />
                        <Route path="stringing" element={<FrameworkStringing />} />
                        <Route path="contact" element={<FrameworkContact />} />
                    </Route>

                    {/* Retired: redirect String Theory routes to Framework */}
                    {ST_REDIRECTS.map(([from, to]) => (
                        <Route key={from} path={from} element={<Navigate to={to} replace />} />
                    ))}

                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />

                    <Route path="/checkout/success" element={<CheckoutSuccess />} />
                    <Route path="/checkout/cancel" element={<CheckoutCancel />} />

                    <Route path="*" element={<Navigate to="/framework" replace />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
